import { getActionTypeFromInstance, NgxsPluginFn } from '@ngxs/store'

export const quoteFlowMetaReducer: NgxsPluginFn = (state, action, next) => {
	const pathsAfterPetUpdate: string[] = [
		'/quoting/start-quote',
		'/quoting/referral',
		'/quoting/pet-details',
	]
	const actionType: string = getActionTypeFromInstance(action) ?? ''
	let updatedState = state
	if (['[Pet] Update'].includes(actionType) && /pet-details/i.test(state.router.state.url)) {
		updatedState = {
			...state,
			quoteFlow: {
				...state.quoteFlow,
				allowedPaths: pathsAfterPetUpdate,
			},
		}
	}

	return next(updatedState, action)
}
